import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table table-striped table-hover table-sm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "small text-muted lh-1" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "small text-muted lh-1" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "small text-muted lh-1" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { class: "small text-muted lh-1" }
const _hoisted_14 = { class: "text-center small" }
const _hoisted_15 = { class: "text-center small" }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-between px-2 py-2" }
const _hoisted_17 = { class: "text-muted small" }
const _hoisted_18 = { "aria-label": "Paginación de direcciones" }
const _hoisted_19 = { class: "pagination pagination-sm mb-0" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "page-item disabled"
}
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "text-end text-muted small m-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
        _createElementVNode("tr", { class: "align-middle" }, [
          _createElementVNode("th", { class: "col" }, [
            _createElementVNode("span", { class: "align-middle" }, "Dirección")
          ]),
          _createElementVNode("th", { class: "col text-center" }, [
            _createElementVNode("span", { class: "" }, "Tipo")
          ]),
          _createElementVNode("th", { class: "col text-center" }, [
            _createElementVNode("span", { class: "" }, "Disponible")
          ]),
          _createElementVNode("th", { class: "col text-center" }, [
            _createElementVNode("span", { class: "" }, "Asignado")
          ]),
          _createElementVNode("th", { class: "col text-center" }, [
            _createElementVNode("span", { class: "" }, "Bloqueado")
          ]),
          _createElementVNode("th", { class: "col text-center" }, [
            _createElementVNode("span", { class: "" }, "Total")
          ]),
          _createElementVNode("th", { class: "col text-center" }, [
            _createElementVNode("span", { class: "" }, "Fecha de Creación")
          ]),
          _createElementVNode("th", { class: "col text-center" }, [
            _createElementVNode("span", { class: "" }, "Fecha de Actualización")
          ])
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (!_ctx.isAddressesLoading && _ctx.addresses.length === 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("td", {
                colspan: "8",
                class: "text-center"
              }, "No hay direcciones disponibles", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.isAddressesLoading)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("td", {
                colspan: "8",
                class: "text-center"
              }, [
                _createElementVNode("i", { class: "fas fa-spinner fa-spin" }),
                _createTextVNode(" Actualizando...")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses, (address) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: address.id,
            class: "align-middle"
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("a", {
                class: "link-success",
                href: 
              'https://blockchair.com/es/bitcoin/address/' + address.address
            ,
                target: "_blank"
              }, _toDisplayString(address.address), 9, _hoisted_4)
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.addressTypeClass(address.type))
              }, _toDisplayString(_ctx.addressTypeLabel(address.type)), 3)
            ]),
            _createElementVNode("td", {
              class: _normalizeClass(["text-center py-1", parseFloat(address.availableAmount) > 0 ? 'fw-bold' : ''])
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(parseFloat(address.availableAmount).toFixed(8)) + " BTC", 1),
              _createElementVNode("div", _hoisted_7, " $ " + _toDisplayString(_ctx.formatUSD(address.availableAmount)) + " USD ", 1)
            ], 2),
            _createElementVNode("td", {
              class: _normalizeClass(["text-center py-1", parseFloat(address.allocatedAmount) > 0 ? 'fw-bold' : ''])
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(parseFloat(address.allocatedAmount).toFixed(8)) + " BTC", 1),
              _createElementVNode("div", _hoisted_9, " $ " + _toDisplayString(_ctx.formatUSD(address.allocatedAmount)) + " USD ", 1)
            ], 2),
            _createElementVNode("td", {
              class: _normalizeClass(["text-center py-1", parseFloat(address.blockedAmount) > 0 ? 'fw-bold' : ''])
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(parseFloat(address.blockedAmount).toFixed(8)) + " BTC", 1),
              _createElementVNode("div", _hoisted_11, " $ " + _toDisplayString(_ctx.formatUSD(address.blockedAmount)) + " USD ", 1)
            ], 2),
            _createElementVNode("td", {
              class: _normalizeClass(["text-center py-1", parseFloat(address.totalAmount) > 0 ? 'fw-bold' : ''])
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(parseFloat(address.totalAmount).toFixed(8)) + " BTC", 1),
              _createElementVNode("div", _hoisted_13, " $ " + _toDisplayString(_ctx.formatUSD(address.totalAmount)) + " USD ", 1)
            ], 2),
            _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatDateTimezone(address.dateCreated)), 1),
            _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatDateTimezone(address.dateUpdated)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, " Página " + _toDisplayString(_ctx.addressesPage + 1) + " de " + _toDisplayString(_ctx.totalPages) + " · " + _toDisplayString(_ctx.addressesTotalCount) + " registros ", 1),
      _createElementVNode("nav", _hoisted_18, [
        _createElementVNode("ul", _hoisted_19, [
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", { disabled: _ctx.addressesPage === 0 || _ctx.isAddressesLoading }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: _ctx.addressesPage === 0 || _ctx.isAddressesLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(0)))
            }, " « ", 8, _hoisted_20)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", { disabled: _ctx.addressesPage === 0 || _ctx.isAddressesLoading }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: _ctx.addressesPage === 0 || _ctx.isAddressesLoading,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevAddressesPage && _ctx.prevAddressesPage(...args)))
            }, " ‹ ", 8, _hoisted_21)
          ], 2),
          (_ctx.showLeftEllipsis)
            ? (_openBlock(), _createElementBlock("li", _hoisted_22, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "page-link" }, "…", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageWindow, (page) => {
            return (_openBlock(), _createElementBlock("li", {
              key: page,
              class: _normalizeClass(["page-item", { active: page === _ctx.addressesPage }])
            }, [
              _createElementVNode("button", {
                class: "page-link",
                type: "button",
                disabled: _ctx.isAddressesLoading,
                onClick: ($event: any) => (_ctx.goToPage(page))
              }, _toDisplayString(page + 1), 9, _hoisted_23)
            ], 2))
          }), 128)),
          (_ctx.showRightEllipsis)
            ? (_openBlock(), _createElementBlock("li", _hoisted_24, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "page-link" }, "…", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", {
            disabled:
              _ctx.addressesPage >= _ctx.totalPages - 1 ||
              _ctx.isAddressesLoading ||
              !_ctx.addressesHasMore,
          }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: 
              _ctx.addressesPage >= _ctx.totalPages - 1 ||
              _ctx.isAddressesLoading ||
              !_ctx.addressesHasMore
            ,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextAddressesPage && _ctx.nextAddressesPage(...args)))
            }, " › ", 8, _hoisted_25)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item", {
            disabled:
              _ctx.addressesPage >= _ctx.totalPages - 1 ||
              _ctx.isAddressesLoading ||
              !_ctx.addressesHasMore,
          }])
          }, [
            _createElementVNode("button", {
              class: "page-link",
              type: "button",
              disabled: 
              _ctx.addressesPage >= _ctx.totalPages - 1 ||
              _ctx.isAddressesLoading ||
              !_ctx.addressesHasMore
            ,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.totalPages - 1)))
            }, " » ", 8, _hoisted_26)
          ], 2)
        ])
      ])
    ]),
    (_ctx.formattedAddressesUpdated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fw-bold" }, "Actualizado:", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.formattedAddressesUpdated), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}